import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useMembers({ onlyActive = false } = {}) {
  const [members, setMembers] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.index, {
        params: {
          onlyActive,
        },
      })
      .then((response) => {
        setMembers(response.data.data);
      });
  }, []);

  return members;
}
